module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "onepage-wrap"
  }, [_c('section', {
    staticClass: "full-screen home"
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.homeImages.humanImage),
      expression: "homeImages.humanImage"
    }],
    attrs: {
      "id": "bg-human"
    }
  }), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.homeImages.titleImage),
      expression: "homeImages.titleImage"
    }],
    attrs: {
      "id": "bg-title"
    }
  }), (!_vm.isMobile) ? _c('img', {
    staticClass: "btn-scroll",
    attrs: {
      "src": require("assets/btn-scroll.png")
    }
  }) : _vm._e(), _c('div', {
    staticClass: "banner-shop"
  }, [_c('div', {
    on: {
      "click": function($event) {
        _vm.videoSwitch = !_vm.videoSwitch
      }
    }
  }, [_c('img', {
    staticStyle: {
      "margin-bottom": "12px"
    },
    attrs: {
      "src": require("assets/banner-KeP.png"),
      "width": "193"
    }
  })]), _c('router-link', {
    attrs: {
      "to": {
        name: 'shopping'
      },
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("assets/banner-shop.png")
    }
  })])], 1), (_vm.videoSwitch) ? _c('div', {
    staticClass: "video-pop"
  }, [_c('div', {
    staticClass: "bg",
    on: {
      "click": function($event) {
        _vm.videoSwitch = !_vm.videoSwitch
      }
    }
  }), _c('div', {
    staticClass: "video-wrap"
  }, [_c('iframe', {
    attrs: {
      "width": _vm.videoWidth,
      "height": _vm.videoHeight,
      "src": "https://www.youtube.com/embed/wKPcFEPUeTU?rel=0&amp;showinfo=0",
      "frameborder": "0",
      "gesture": "media",
      "allowfullscreen": "allowfullscreen"
    }
  }), _c('div', {
    staticClass: "video-close",
    on: {
      "click": function($event) {
        _vm.videoSwitch = !_vm.videoSwitch
      }
    }
  }, [_vm._v("關閉影片")])], 1)]) : _vm._e()]), _c('section', {
    staticClass: "CountDown-wrap"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _c('h1', [_vm._v("距離 WirForce 還有 ...")]), _c('countdown', {
    staticClass: "countDownTimer",
    attrs: {
      "time": _vm.countDownTimer
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('span', {
          staticClass: "timerNum"
        }, [_vm._v(_vm._s(props.days))]), _c('span', {
          staticClass: "timerText"
        }, [_vm._v("天")]), _c('span', {
          staticClass: "timerNum"
        }, [_vm._v(_vm._s(props.hours))]), _c('span', {
          staticClass: "timerText"
        }, [_vm._v("小時")]), _c('span', {
          staticClass: "timerNum"
        }, [_vm._v(_vm._s(props.minutes))]), _c('span', {
          staticClass: "timerText"
        }, [_vm._v("分鐘")]), _c('span', {
          staticClass: "timerNum"
        }, [_vm._v(_vm._s(props.seconds))]), _c('span', {
          staticClass: "timerText"
        }, [_vm._v("秒")])]
      }
    }])
  })], 1)]), _c('section', {
    staticClass: "buying-process"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(1), _c('h1', [_vm._v("什麼是 WirForce？")]), _c('p', [_vm._v("臺灣也有自己的 Lan Party！歡迎來到 WirForce 2017！本次 BYOC 座位將會擴增超過 1,000 席，同時各大知名品牌與相關活動將齊聚一堂。讓我們再次攜手創造亞洲有史以來最空前的電競盛會。")]), _c('div', {
    staticClass: "mb-20"
  }), _vm._m(2), _c('h1', [_vm._v("什麼是 Bring Games To Live？")]), _vm._m(3), _c('div', {
    staticClass: "mb-20"
  }), _vm._m(4), _c('h1', [_vm._v("活動時間、地點")]), _c('h4', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("時間：2017 年 11 月 23 日（四）11:00 – 11 月 26 日（日）17:30")]), _c('h4', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("地點：花博爭艷館")]), _c('div', {
    staticClass: "mb-4"
  }), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a', {
    staticClass: "btn ghost-btn",
    attrs: {
      "href": _vm.googleCalenderEvent,
      "target": "_blank"
    }
  }, [_vm._v("加到 Google 行事曆")])]), _c('div', {
    staticClass: "mb-10"
  }), _c('img', {
    directives: [{
      name: "img",
      rawName: "v-img:group",
      value: ({
        src: ''
      }),
      expression: "{src: ''}",
      arg: "group"
    }],
    staticStyle: {
      "display": "block",
      "max-width": "100%",
      "margin": "0 auto"
    },
    attrs: {
      "src": require("assets/location-map.png")
    }
  }), _c('div', {
    staticClass: "mb-10"
  }), _vm._m(5), _c('h1', [_vm._v("購票流程")]), _vm._m(6), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('router-link', {
    staticClass: "btn",
    attrs: {
      "to": {
        name: 'ticketType'
      }
    }
  }, [_vm._v("立即購票")]), _c('router-link', {
    staticClass: "btn",
    attrs: {
      "to": {
        name: 'selectArea'
      }
    }
  }, [_vm._v("劃位 / 座位圖")])], 1)])]), _c('section', {
    staticClass: "gamily"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(7), _c('h1', [_vm._v("WirForce 唯一指定遊戲社群APP")]), _c('div', {
    staticClass: "gamily-slider-wrap left",
    on: {
      "mouseover": function($event) {
        _vm.sliderStop = !_vm.sliderStop
      },
      "mouseout": function($event) {
        _vm.sliderStop = !_vm.sliderStop
      }
    }
  }, [_c('div', {
    staticClass: "gamily-sliders"
  }, _vm._l((_vm.gamilySlider), function(slider, index) {
    return _c('img', {
      staticClass: "img-responsive",
      class: {
        'slider-on': _vm.sliderOn === index
      },
      attrs: {
        "src": slider
      }
    })
  })), _vm._m(8), _c('div', {
    staticClass: "arrows"
  }, [_c('div', {
    staticClass: "arrow next",
    on: {
      "click": function($event) {
        _vm.sliderGo('next')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-right"
  })]), _c('div', {
    staticClass: "arrow pre",
    on: {
      "click": function($event) {
        _vm.sliderGo('pre')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  })])]), _c('div', {
    staticClass: "slider-dotts"
  }, [_c('div', {
    staticClass: "title-decoration"
  }, [_c('div', {
    staticClass: "dot",
    class: {
      'actived': _vm.sliderOn === 0
    },
    on: {
      "click": function($event) {
        _vm.sliderOn = 0
      }
    }
  }), _c('div', {
    staticClass: "dot",
    class: {
      'actived': _vm.sliderOn === 1
    },
    on: {
      "click": function($event) {
        _vm.sliderOn = 1
      }
    }
  }), _c('div', {
    staticClass: "dot",
    class: {
      'actived': _vm.sliderOn === 2
    },
    on: {
      "click": function($event) {
        _vm.sliderOn = 2
      }
    }
  }), _c('div', {
    staticClass: "dot",
    class: {
      'actived': _vm.sliderOn === 3
    },
    on: {
      "click": function($event) {
        _vm.sliderOn = 3
      }
    }
  })])])]), _vm._m(9)])]), _c('section', [_vm._m(10), _c('div', {
    staticClass: "container",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "mb-8"
  }), _c('router-link', {
    attrs: {
      "to": {
        name: 'shopping'
      },
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "src": require("assets/section-shop-banner.jpg")
    }
  })]), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('router-link', {
    staticClass: "l btn ghost-btn red",
    attrs: {
      "to": {
        name: 'shopping'
      },
      "target": "_blank"
    }
  }, [_vm._v("BUY IT")])], 1)], 1)]), _c('section', [_c('div', {
    staticClass: "container"
  }, [_vm._m(11), _c('h1', [_vm._v("節目表")]), _c('programList')], 1)]), _c('section', {
    staticClass: "gallery"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(12), _c('h1', [_vm._v("精彩花絮")]), _c('div', {
    staticClass: "lightbox row"
  }, [_c('img', {
    directives: [{
      name: "img",
      rawName: "v-img:gallery",
      value: ({
        src: ''
      }),
      expression: "{src: ''}",
      arg: "gallery"
    }],
    staticClass: "col-md-3 col-xs-6",
    attrs: {
      "src": require("assets/gallery/gallery01.jpg")
    }
  }), _c('img', {
    directives: [{
      name: "img",
      rawName: "v-img:gallery",
      value: ({
        src: ''
      }),
      expression: "{src: ''}",
      arg: "gallery"
    }],
    staticClass: "col-md-3 col-xs-6",
    attrs: {
      "src": require("assets/gallery/gallery02.jpg")
    }
  }), _c('img', {
    directives: [{
      name: "img",
      rawName: "v-img:gallery",
      value: ({
        src: ''
      }),
      expression: "{src: ''}",
      arg: "gallery"
    }],
    staticClass: "col-md-3 col-xs-6",
    attrs: {
      "src": require("assets/gallery/gallery03.jpg")
    }
  }), _c('img', {
    directives: [{
      name: "img",
      rawName: "v-img:gallery",
      value: ({
        src: ''
      }),
      expression: "{src: ''}",
      arg: "gallery"
    }],
    staticClass: "col-md-3 col-xs-6",
    attrs: {
      "src": require("assets/gallery/gallery04.jpg")
    }
  }), _c('img', {
    directives: [{
      name: "img",
      rawName: "v-img:gallery",
      value: ({
        src: ''
      }),
      expression: "{src: ''}",
      arg: "gallery"
    }],
    staticClass: "col-md-3 col-xs-6",
    attrs: {
      "src": require("assets/gallery/gallery05.jpg")
    }
  }), _c('img', {
    directives: [{
      name: "img",
      rawName: "v-img:gallery",
      value: ({
        src: ''
      }),
      expression: "{src: ''}",
      arg: "gallery"
    }],
    staticClass: "col-md-3 col-xs-6",
    attrs: {
      "src": require("assets/gallery/gallery06.jpg")
    }
  }), _c('img', {
    directives: [{
      name: "img",
      rawName: "v-img:gallery",
      value: ({
        src: ''
      }),
      expression: "{src: ''}",
      arg: "gallery"
    }],
    staticClass: "col-md-3 col-xs-6",
    attrs: {
      "src": require("assets/gallery/gallery07.jpg")
    }
  }), _c('img', {
    directives: [{
      name: "img",
      rawName: "v-img:gallery",
      value: ({
        src: ''
      }),
      expression: "{src: ''}",
      arg: "gallery"
    }],
    staticClass: "col-md-3 col-xs-6",
    attrs: {
      "src": require("assets/gallery/gallery08.jpg")
    }
  }), _c('img', {
    directives: [{
      name: "img",
      rawName: "v-img:gallery",
      value: ({
        src: ''
      }),
      expression: "{src: ''}",
      arg: "gallery"
    }],
    staticClass: "col-md-3 col-xs-6",
    attrs: {
      "src": require("assets/gallery/gallery09.jpg")
    }
  }), _c('img', {
    directives: [{
      name: "img",
      rawName: "v-img:gallery",
      value: ({
        src: ''
      }),
      expression: "{src: ''}",
      arg: "gallery"
    }],
    staticClass: "col-md-3 col-xs-6",
    attrs: {
      "src": require("assets/gallery/gallery10.jpg")
    }
  }), _c('img', {
    directives: [{
      name: "img",
      rawName: "v-img:gallery",
      value: ({
        src: ''
      }),
      expression: "{src: ''}",
      arg: "gallery"
    }],
    staticClass: "col-md-3 col-xs-6",
    attrs: {
      "src": require("assets/gallery/gallery11.jpg")
    }
  }), _c('img', {
    directives: [{
      name: "img",
      rawName: "v-img:gallery",
      value: ({
        src: ''
      }),
      expression: "{src: ''}",
      arg: "gallery"
    }],
    staticClass: "col-md-3 col-xs-6",
    attrs: {
      "src": require("assets/gallery/gallery12.jpg")
    }
  })])])]), _c('div', {
    staticClass: "mb-20"
  }), (_vm.popBanner && _vm.isMobile) ? _c('div', {
    staticClass: "pop-banner"
  }, [_c('div', {
    staticClass: "pop-content"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'shopping'
      },
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "src": require("assets/banner-shop-mobile.jpg")
    }
  })]), _c('div', {
    staticClass: "btn pop-close",
    on: {
      "click": function($event) {
        _vm.popBanner = !_vm.popBanner
      }
    }
  }, [_vm._v("CLOSE")])], 1)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-decoration"
  }, [_c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-decoration"
  }, [_c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-decoration"
  }, [_c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("WirForce 2017 今年活動主軸「Bring Games To Live」，深刻實踐「玩家 vs. 遊戲」新世代的緊密關聯。"), _c('br'), _vm._v("遊戲因為玩家社群的存在，發展電競、實況、影劇、同人創作、Cosplay 等多元面向，大幅拓寬遊戲作為產品以外的發展可能性；玩家因為遊戲獲得樂趣，進而成為人生志向與生涯發展的重要關鍵。"), _c('br'), _vm._v("所有一切都將在 WirForce 2017 獲得實踐，這是屬於玩家的終極遊戲舞台。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-decoration"
  }, [_c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-decoration"
  }, [_c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "process-block-wrap"
  }, [_c('div', {
    staticClass: "process-block"
  }, [_c('img', {
    attrs: {
      "src": require("assets/ticket-process01.png")
    }
  }), _c('div', {
    staticClass: "title"
  }, [_vm._v("選票")])]), _c('div', {
    staticClass: "process-block"
  }, [_c('img', {
    attrs: {
      "src": require("assets/ticket-process02.png")
    }
  }), _c('div', {
    staticClass: "title"
  }, [_vm._v("付款")])]), _c('div', {
    staticClass: "process-block"
  }, [_c('img', {
    attrs: {
      "src": require("assets/ticket-process03.png")
    }
  }), _c('div', {
    staticClass: "title"
  }, [_vm._v("劃位")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-decoration"
  }, [_c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gamily-slider-layout"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": require("assets/gamily/phone.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-text"
  }, [_c('div', {
    staticClass: "mb-6"
  }), _c('div', {
    staticClass: "text-red"
  }, [_vm._v("WirForce 2017所有最新消息盡在 GAMily！")]), _c('div', {
    staticClass: "text-white"
  }, [_vm._v("遊戲 X 實況 X 電競 X 硬體 X 網紅 =  GAMily")]), _c('div', {
    staticClass: "mb-6"
  }), _c('div', {
    staticClass: "text-red"
  }, [_vm._v("這是一款全新的遊戲社群 APP")]), _c('div', {
    staticClass: "paragraph-wrap"
  }, [_c('div', {
    staticClass: "em-title"
  }, [_c('div', {
    staticClass: "icon-logo"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("玩家可以自由創立家族，邀請遊戲與公會中的夥伴一同探索。")])]), _c('div', {
    staticClass: "em-title"
  }, [_c('div', {
    staticClass: "icon-logo"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("發表優質的攻略文與分享文，可讓您有機會獲得其他成員的斗內！")])]), _c('div', {
    staticClass: "em-title"
  }, [_c('div', {
    staticClass: "icon-logo"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("具備聊天室功能，限定家族成員才能進入。")])]), _c('div', {
    staticClass: "em-title"
  }, [_c('div', {
    staticClass: "icon-logo"
  }), _c('div', {
    staticClass: "text"
  }, [_vm._v("實況名人殺梗、小葵、小嵐...等名人家族跟玩家一同成為夥伴！")])])]), _c('div', {
    staticClass: "text-grey"
  }, [_vm._v("2017年，GAMily 成為 WirForce 大會唯一指定 遊戲社群 APP，目前已經內建 WirForce 大會及 BYOC ⋯等官方家族。"), _c('br'), _vm._v("未來的 WirForce 大會資訊、舞台活動、BYOC 活動等等，在 GAMily 都有最即時的更新喔！"), _c('br'), _c('br'), _vm._v("GAMily遊戲家族募集中，成為遊戲領域的第一個創族者就是你！"), _c('br'), _vm._v("在您的手機商店搜尋「 GAMily遊戲社群 」或掃描 QR CODE，加入就是現在！")]), _c('div', {
    staticClass: "mb-6"
  }), _c('div', {
    staticClass: "gamily-link"
  }, [_c('a', {
    attrs: {
      "href": "https://gami.ly/c/wirforce?referrer=utm_source%3Dwirforce%26utm_medium%3Dinstall%26utm_campaign%3Dgame_forum_integration",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "qrcode",
    attrs: {
      "src": require("assets/gamily/qrcode.png")
    }
  })]), _c('a', {
    staticClass: "btn ghost-btn red",
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "href": "https://gami.ly/c/wirforce",
      "target": "_blank"
    }
  }, [_vm._v("前往 Gamily")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "title-decoration"
  }, [_c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  })]), _c('h1', [_vm._v("周邊商品")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-decoration"
  }, [_c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-decoration"
  }, [_c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  }), _c('div', {
    staticClass: "dot"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22882d0a"}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/homepage.vue
// module id = 561
// module chunks = 1